import { spawn, all } from "redux-saga/effects";
import authSagas from "../sagas/auth.sagas";
import spSagas from "../sagas/sp.sagas";
import participantSagas from "../sagas/participant.sagas";
import CosSagas from "../sagas/cos.sagas";
import ahSagas from "../sagas/ah.sagas";
import rosteringSagas from "../sagas/rostering.sagas";
import employeeSagas from "../sagas/employee.sagas";
import silSagas from "../sagas/sil.sagas";
import incidentSagas from "../sagas/incident.sagas";
import auditSagas from "../sagas/audit.sagas";
import journeySagas from "../sagas/journey.sagas";
import vertex360CopilotSagas from "../sagas/vertex360Copilot.sagas";
import careWatchSagas from "../sagas/careWatch.sagas";
import bulkAnalyseSagas from "../sagas/bulkAnalyse.sagas";

export default function* rootSaga() {
  yield all([spawn(CosSagas)]);
  yield all([spawn(ahSagas)]);
  yield all([spawn(authSagas)]);
  yield all([spawn(spSagas)]);
  yield all([spawn(participantSagas)]);
  yield all([spawn(rosteringSagas)]);
  yield all([spawn(employeeSagas)]);
  yield all([spawn(silSagas)]);
  yield all([spawn(incidentSagas)]);
  yield all([spawn(auditSagas)]);
  yield all([spawn(journeySagas)]);
  yield all([spawn(vertex360CopilotSagas)]);
  yield all([spawn(careWatchSagas)]);
  yield all([spawn(bulkAnalyseSagas)]);
}
